import React from 'react'

const GroupNotesByTableIcon = ({ groupNotesBy }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1287_4889)">
        <path
          d="M4.6665 7C4.6665 6.35567 5.18884 5.83333 5.83317 5.83333H22.1665C22.8108 5.83333 23.3332 6.35567 23.3332 7V21C23.3332 21.6443 22.8108 22.1667 22.1665 22.1667H5.83317C5.18884 22.1667 4.6665 21.6443 4.6665 21V7Z"
          stroke={groupNotesBy === 'table' ? '#FF4A8E' : 'black'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 11.6667H23.3332"
          stroke={groupNotesBy === 'table' ? '#FF4A8E' : 'black'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 16.3333H23.3332"
          stroke={groupNotesBy === 'table' ? '#FF4A8E' : 'black'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6665 11.6667V22.1667"
          stroke={groupNotesBy === 'table' ? '#FF4A8E' : 'black'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1287_4889">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GroupNotesByTableIcon
